import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative w-full flex flex-col items-center pt-12 pb-16 px-6 md:px-12 overflow-hidden" data-id="element-41">
      {/* Background Glows */}
      <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-gold-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-42" />
      <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-cyan-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-43" />

      <div className="max-w-5xl mx-auto w-full flex flex-col items-center text-center relative z-10" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-center gap-6" data-id="element-45">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-carbon-800/80 border border-gold-500/20 w-fit backdrop-blur-sm" data-id="element-46">
            <div className="w-2 h-2 rounded-full bg-gold-500 shadow-[0_0_8px_rgba(212,175,55,0.6)]" data-id="element-47" />
            <span className="text-xs font-medium text-gold-300 tracking-wide uppercase" data-id="element-48">
              Sistema Automatizado
            </span>
          </div>

          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-semibold text-white leading-[1.1] tracking-tight" data-id="element-49">
            Copiá mis operativas de{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-300 via-gold-500 to-gold-600" data-id="element-50">
              oro en automático
            </span>
          </h1>

          <p className="text-lg md:text-xl text-gray-300 leading-relaxed font-light max-w-3xl mb-8" data-id="element-51">
            Day Trader Oro es mi sistema de copy trading donde podés copiar las
            mismas operaciones que realizo en mis cuentas de fondeo, cuentas
            reales y comunidad privada.
          </p>
        </motion.div>

        {/* Video Player */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="w-full aspect-video rounded-2xl md:rounded-3xl overflow-hidden bg-carbon-900 border border-carbon-800 shadow-[0_20px_50px_rgba(0,0,0,0.5)] relative z-20" data-id="element-52">
          <video className="w-full h-full object-cover" controls preload="metadata" data-id="element-53">
            <source src="https://cdn.magicpatterns.com/uploads/88TRS6vC647ooQPnzLxUwU/0622%20(1).mov" type="video/mp4" data-id="element-54" />
            Tu navegador no soporta la reproducción de videos.
          </video>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-12 inline-block px-6 py-3 rounded-full bg-carbon-900 border border-carbon-800" data-id="element-55">
          <p className="text-gold-300 font-medium tracking-wide" data-id="element-56">
            ⬇️ Hacé todo paso a paso en el orden de abajo ⬇️
          </p>
        </motion.div>
      </div>
    </section>;
}